import { Dialog } from '@headlessui/react';
import React from 'react';

import { Button } from '@/components/Button';

export interface Props {
  title: React.ReactNode;
  description: React.ReactNode;
  hasCancelButton?: boolean;
  okButtonLabel?: string;
  cancelButtonLabel?: string;
  okButtonDisabled?: boolean;
  onOk?: (onClose: () => void) => void;
  onCancel?: (onClose: () => void) => void;
  onClose?: () => void;
}

const ModalTemplate: React.FC<Props> = ({
  title,
  description,
  hasCancelButton,
  okButtonLabel,
  cancelButtonLabel,
  okButtonDisabled = false,
  onOk,
  onCancel,
  onClose = () => null,
}) => {
  return (
    <>
      <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
        {title}
      </Dialog.Title>
      <Dialog.Description
        as="p"
        className="mt-6 text-sm text-gray-700 whitespace-pre-line"
      >
        {description}
      </Dialog.Description>
      <div className="mt-8 flex flex-row-reverse">
        <Button
          variant="solid-light"
          onClick={() => (onOk ? onOk(onClose) : onClose())}
          disabled={okButtonDisabled}
        >
          {okButtonLabel}
        </Button>

        {hasCancelButton && (
          <Button
            className="mr-4"
            variant="text"
            onClick={() => (onCancel ? onCancel(onClose) : onClose())}
          >
            {cancelButtonLabel}
          </Button>
        )}
      </div>
    </>
  );
};

ModalTemplate.defaultProps = {
  hasCancelButton: true,
  okButtonLabel: '확인',
  cancelButtonLabel: '취소',
};

export default ModalTemplate;
